export default __webpack_public_path__ + "static/icon-c0fc09b88c2954e8ca301b3e65d0658e.svg";